import Icon from '../Icon'

type CheckboxProps = {
  text: string
  checked: boolean
  onChange: () => void
}
function Checkbox({ text, checked, onChange }: CheckboxProps) {
  return (
    <button onClick={onChange} className='flex items-center gap-2 text-left'>
      {checked ? (
        <Icon name='MdOutlineCheckBox' size={24} />
      ) : (
        <Icon name='MdOutlineCheckBoxOutlineBlank' size={24} />
      )}
      <p>{text}</p>
    </button>
  )
}

export default Checkbox
